import * as React from 'react';


export default class extends React.Component<any,
    any> {


    constructor(props) {
        super(props);
    }
componentDidUpdate(prevProps, prevState) {
        // this.state = prevProps;
        // this.setState({ loading: prevProps.loading })
    }

    renderLoadingPlaceHolder() {

        return <div className="timeline-item">
            <div className="row">
                <div className="col-md-6 bg-white py-3 ">
                    <div className="animated-background h-avatar-small"></div>
                </div>
                <div className="col-md-6 bg-white py-3 ">
                    <div className="animated-background h-text-1"></div>
                    <div className="animated-background h-text-2"></div>
                    <div className="animated-background h-text-3"></div>
                </div>
            </div>
            <div className="row my-2">
                <div className="col-md-6 bg-white py-3 ">
                    <div className="animated-background h-avatar-small"></div>
                </div>
                <div className="col-md-6 bg-white py-3 ">
                    <div className="animated-background h-text-1"></div>
                    <div className="animated-background h-text-2"></div>
                    <div className="animated-background h-text-3"></div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 bg-white py-3 ">
                    <div className="animated-background h-avatar-small"></div>
                </div>
                <div className="col-md-6 bg-white py-3 ">
                    <div className="animated-background h-text-1"></div>
                    <div className="animated-background h-text-2"></div>
                    <div className="animated-background h-text-3"></div>
                </div>
            </div>



        </div>

    }

    renderLoading() {
        return <div className="w-full text-center">
            <button className="btn btn-warning disabled  btn-lg" style={{ color: "#fff" }}>
                <i className="fa fa-refresh fa-spin"></i> {this.props.message || 'Loading...'}</button>
        </div>

    }

    render() {
        return (
            <div>
                {

                    this.props.loading ?
                        this.props.type === 'placeholde' ? this.renderLoadingPlaceHolder() : this.renderLoading()
                        : null
                }
            </div>
        )

    }
}
